<svg
  xmlns="http://www.w3.org/2000/svg"
  viewBox="10 10 100 100"
>
  <path
    d="M66.7 31.5c-.2-.8 0-1.7.6-2.3l11.6-11.6c.6-.6 1.5-.8 2.3-.6l8.2 2.2-9.3 9.3c-.6.6-.8 1.5-.6 2.3l1.7 6.4c.2.8.9 1.5 1.7 1.7l6.4 1.7c.8.2 1.7 0 2.3-.6l9.3-9.3 2.2 8.2c.2.8 0 1.7-.6 2.3L90.8 52.7c-.6.6-1.5.8-2.3.6l-9.6-2.6-28.1 28.2 2.6 9.6c.2.8 0 1.7-.6 2.3l-11.6 11.6c-.6.6-1.5.8-2.3.6l-8.2-2.2 9.3-9.3c.6-.6.8-1.5.6-2.3l-1.7-6.4c-.2-.8-.9-1.5-1.7-1.7l-6.4-1.7c-.8-.2-1.7 0-2.3.6l-9.3 9.3-2.2-8.1c-.2-.8 0-1.7.6-2.3l11.6-11.6c.6-.6 1.5-.8 2.3-.6l9.6 2.6 28.1-28.1-2.5-9.7z"
    style="fill: #a3a3a3"
  />
  <path
    d="m102.4 98.1-4.3 4.3-5.6-3.1-1.5-3.9-34.8-34.8 4.4-4.4 34.7 34.7 3.9 1.5z"
    style="fill: #727272"
  />
  <path
    data-player="true"
    d="M55.9 42.4 31.5 18c-.6-.6-1.6-.5-2.3.1L18.1 29.2c-.7.7-.7 1.7-.1 2.3l24.4 24.4c.6.6 1.6.5 2.3-.1.7-.7 1.7-.7 2.3-.1l.6.6c.6.6.5 1.6-.1 2.3-.7.7-.7 1.7-.1 2.3l5.9 5.9c.6.6 1.6.5 2.3-.1l11.1-11.1c.7-.7.7-1.7.1-2.3l-5.9-5.9c-.6-.6-1.6-.5-2.3.1-.7.7-1.7.7-2.3.1l-.7-.6c-.6-.6-.5-1.6.1-2.3.7-.7.8-1.7.2-2.3z"
    style="fill: #808080"
  />
</svg>
